import { ClickAwayListener, IconButton, Tooltip } from '@mui/material';
import { memo, ReactNode, useState } from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface Props {
  guidanceText: ReactNode;
  placement?: any;
}

/**
 * HelpButton (ClickでTooltip表示/非表示)
 * @param guidanceText 表示内容
 * @param placement ToolTipの表示位置
 * @returns HelpButton
 */
export const HelpButton = memo(({ guidanceText, placement }: Props) => {
  const [open, setOpen] = useState(false);
  const handleTooltipClose = () => {
    setOpen(false);
  };
  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        arrow
        placement={placement}
        open={open}
        title={guidanceText}
        slotProps={{
          popper: {
            disablePortal: true,
          },
        }}>
        <IconButton color="inherit" onClick={handleTooltipOpen}>
          <HelpOutlineIcon style={{ color: 'gray' }} />
        </IconButton>
      </Tooltip>
    </ClickAwayListener>
  );
});
